<div class="boxWhite">
  <h4>CAMBIAR SUCURSAL</h4>

  <button class="btn btnClose" (click)="close()" *ngIf="!forzado">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="contModal">
    <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
      <div class="d-flex flex-column justify-content-center">
        <h6>SUCURSALE(S) SELECCIONADA(S)</h6>
        <p class="clBlue m-0 fw-medium" >{{getSucursalesSeleccionadasTmpComoTexto()}}</p>
      </div>
    </div>


    <div class="checkboxes">
      <label class="itemCheck">
        <input type="checkbox" [checked]="todosMarcado" (change)="marcarTodas($event)">
        <span class="boxCheck">TODOS</span>
      </label>

      <label class="itemCheck" *ngFor="let sucursal of listaSucursales">
        <input type="checkbox" [checked]="sucursal.seleccionada" (change)="marcarSeleccion($event, sucursal)">
        <span class="boxCheck">{{sucursal.nombre}}</span>
      </label>

    </div>

  </div>

  <div class="footModal">
    <button class="btn btnGray w-100" (click)="cambiarSucursal()">CAMBIAR SUCURSAL</button>
  </div>
</div>

